import React, { useContext } from 'react';
import {
	Popover,
	Button,
	InputLabel,
	Box,
	Typography,
} from '@material-ui/core';
import Calendar from './Calendar';
import PropTypes from 'prop-types';
import styles from './calendarStyle';
import { getFormattedDate } from '../Filter/util';
import { DateRangeContext } from '../../context/appcontext';
import CALENDARSVG from '../../assets/SVGs/Calendar.svg';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';
import { useLocation } from 'react-router-dom';

function ShowCalender({
	open,
	anchorEl,
	cbHandleClose,
	handleWeekChange,
	handleCloseMenu,
}) {
	const { dateRange, calendarUpdate, setCalendarUpdate } =
		useContext(DateRangeContext);

	const location = useLocation();

	const { week1, week2, start, end } = dateRange;

	let enableApply = true;

	if (location?.pathname?.includes('/dashboard/guided-insights') || location?.pathname?.includes('/details/store-drilldown')) {
		if (week2 >= week1) {
			enableApply = week2 - week1 + 1 < 4 ? false : true;
		} else {
			enableApply = week2 - (week1 - 52) + 1 < 4 ? false : true;
		}
	}

	const handleClose = () => {
		setCalendarUpdate(false);
		handleCloseMenu();
		cbHandleClose();
	};

	const classes = styles();

	const handleApply = () => {
		setCalendarUpdate(false);
		handleCloseMenu();
		handleWeekChange({
			target: {
				value: -1,
				startWeek: week1,
				endWeek: week2,
				startDate: start?.format('YYYY-MM-DD'),
				endDate: end?.format('YYYY-MM-DD'),
			},
		});
		cbHandleClose();
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.CUSTOMWEEK_APPLIED,
		});
	};

	return (
		<Popover
			id={'cal-popover'}
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			elevation={1}
			sx={{ borderLeft: '0px solid #fff' }}
			disableEnforceFocus
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}>
			<Box>
				<Box
					style={{
						display: 'flex',
						flexDirection: 'row',
						padding: '16px 16px 16px 20px',
						alignItems: 'center',
						lineHeight: '24px',
						borderBottom: '1px solid var(--dadce-0, #DADCE0)',
					}}>
					<Box
						sx={{
							margin: '0 8px 0 2px',
						}}>
						<img src={CALENDARSVG} alt="Channel partner"></img>
					</Box>
					<Typography
						style={{
							fontSize: '14px',
							fontFamily: 'Bogle',
						}}>
						{`${getFormattedDate(
							dateRange?.start,
							'MMM DD, YYYY'
						)} - ${getFormattedDate(dateRange?.end, 'MMM DD, YYYY')}`}
					</Typography>
				</Box>
				<Calendar />
				<Box
					id="accordian-footer"
					sx={{
						borderTop: '1px solid var(--dadce-0, #DADCE0)',
					}}>
					<Box
						style={{
							display: 'flex',
							fontSize: 14,
							marginTop: 15,
							marginRight: 15,
							marginBottom: 15,
							fontFamily: 'Bogle-Medium',
							justifyContent: 'end',
						}}
						id="actionBtns">
						<Button
							variant="outlined"
							size="medium"
							className={`${classes.button} ${classes.cancelBtn}`}
							id="cancelBtn"
							onClick={handleClose}>
							<InputLabel
								className={classes.label}
								style={{
									color: '#3c228a',
								}}>
								Cancel
							</InputLabel>
						</Button>
						<Button
							disabled={!calendarUpdate || !enableApply ? true : false}
							id="applyBtn"
							data-testid="applyBtnCalendar"
							className={`${classes.button} ${classes.applyBtn}`}
							onClick={handleApply}>
							<InputLabel
								className={classes.label}
								style={{
									color: '#ffffff',
								}}>
								Apply
							</InputLabel>
						</Button>
					</Box>
				</Box>
			</Box>
		</Popover>
	);
}

ShowCalender.propTypes = {
	open: PropTypes.bool,
	anchorEl: PropTypes.object,
	cbHandleClose: PropTypes.func,
	handleWeekChange: PropTypes.func,
	handleCloseMenu: PropTypes.func,
};

export default ShowCalender;
